// extracted by mini-css-extract-plugin
export default {"updatePasswordContainer":"UpdatePasswordModal_updatePasswordContainer__whzAz"};